import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getSystemConfig } from '../../services/session/systemConfig.js'

const propTypes = {
  children: PropTypes.node
}

const defaultProps = {}

class DefaultFooter extends Component {
  constructor(props) {
    super(props)

    this.getUpdateMessage = this.getUpdateMessage.bind(this)

    var env = process.env.NODE_ENV
    if (env.toLowerCase() === 'production') {
      env = ''
    }

    this.state = {
      systemConfig: getSystemConfig(),
      environment: env
    }
  }
  getUpdateMessage() {
    // if (this.state.systemConfig.systemWarningMessage !== undefined && this.state.systemConfig.systemWarningMessage !== "") {
    //     return this.state.systemConfig.systemWarningMessage;
    // } else {
    var currentDate = new Date()
    var currentHour = currentDate.getHours()

    if (currentHour >= 11 && currentHour < 16) {
      return ' Datos actualizados a las 11:00.'
    } else if (currentHour >= 16 && currentHour < 22) {
      return ' Datos actualizados a las 16:00'
    } else if (currentHour >= 22 || currentHour < 11) {
      return ' Datos actualizados a las 22:00'
    } else {
      return ' Horario de actualizaci\u00F3n de los datos: 11:00, 16:00 y 22:00'
    }
    //    }
  }
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props

    return (
      <React.Fragment>
        <span
          className="alert alert-primary"
          role="alert"
          style={{
            textAlign: 'center',
            marginBottom: '0',
            marginLeft: '-10px',
            padding: '0.50rem 1.25rem',
            float: 'left',
            fontSize: 'smaller'
          }}
        >
          <i className="fa fa-warning  pr-1" style={{ marginRight: '10px' }} />
          {this.getUpdateMessage()}
        </span>
        <span style={{ float: 'left' }}>{this.state.environment}</span>

        <span className="ml-auto">
          Powered by <a href="https://conway.es">Conway</a>
        </span>
      </React.Fragment>
    )
  }
}

DefaultFooter.propTypes = propTypes
DefaultFooter.defaultProps = defaultProps

export default DefaultFooter
